import { render, staticRenderFns } from "./CodeLogin.vue?vue&type=template&id=35a3da96&scoped=true"
import script from "./CodeLogin.vue?vue&type=script&lang=js"
export * from "./CodeLogin.vue?vue&type=script&lang=js"
import style0 from "./CodeLogin.vue?vue&type=style&index=0&id=35a3da96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3da96",
  null
  
)

export default component.exports